import {
    HttpClient,
    HttpEvent,
    HttpEventType,
    HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { catchErrorLogRet } from '../../common/rest.operators';

import { FileValue } from './model/file-value.model';
import { UploadResult } from './model/upload-result.model';

@Injectable()
export class FileService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    createTicket(): Observable<string> {
        return this._http
            .post(
                `${this._appConfig.API_ENDPOINTS.OBJECT_STORE}/tickets`,
                null,
                {
                    responseType: 'text',
                },
            )
            .pipe(catchErrorLogRet(null));
    }

    upload(bucketId: string, files: FileValue[]): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();
        files.forEach((e) => {
            if (e.file != null) {
                if (e.file instanceof Blob) {
                    formData.append(e.name, e.file, e.name);
                }
                if (e.file instanceof File) {
                    formData.append(
                        e.name ?? e.file.name,
                        e.file,
                        e.name ?? e.file.name,
                    );
                }
            }
        });
        return this._http.post(
            `${this._appConfig.API_ENDPOINTS.OBJECT_STORE}/buckets/${bucketId}`,
            formData,
            {
                observe: 'events',
                reportProgress: true,
            },
        );
    }

    uploadWithProgress(
        bucketId: string,
        files: FileValue[],
    ): Observable<number | UploadResult | null> {
        return this.upload(bucketId, files).pipe(
            map((event) => {
                if (event.type === HttpEventType.UploadProgress) {
                    if (event.total == null) {
                        return null;
                    }
                    const val = Math.round(event.loaded / event.total);
                    return Math.max(Math.min(val, 100), 0);
                } else if (event instanceof HttpResponse) {
                    return event.body;
                }
                return null;
            }),
            catchErrorLogRet(null),
        );
    }
}
